import type { ReactNode } from "react";
import { formatTime } from "@/shared/lib/date-formats";
import { TimelineContext, type TimelineState } from "./context";
import { scale, type TimelineDensity } from "./scale";

interface TimelineProviderProps extends TimelineState {
  /**
   * Anchors the gutter to wall-clock. Without it the gutter reads "N min",
   * which is all a definition can say — it has no start.
   */
  startsAt?: string;
  density: TimelineDensity;
  children: ReactNode;
}

export function TimelineProvider({ density, startsAt, children, ...state }: TimelineProviderProps) {
  return (
    <TimelineContext
      value={{
        state,
        actions: {},
        meta: {
          density,
          scale: (minutes) => scale(minutes, density),
          at: (minutes) =>
            startsAt ? formatTime(new Date(new Date(startsAt).getTime() + minutes * 60000)) : `${minutes} min`,
        },
      }}
    >
      {children}
    </TimelineContext>
  );
}
